import { useId } from '@/hooks';
import type { FC } from 'react';
import { ProjectLedgerContent } from '../_components/ProjectLedgerContent';
import { useProjectLedgerData } from '../_hooks/useProjectLedgerData';

/**
 * 一括帳票出力ページ
 */
export const BulkPrintLedgerPage: FC = () => {
  const { id } = useId();

  // データ取得
  const ledgerData = useProjectLedgerData(id);

  return (
    <ProjectLedgerContent
      projectId={id}
      ledgerData={ledgerData}
      // be側のplaywrightで存在判定のために必要
      pageId="bulk-print-ledger-content"
    />
  );
};
